export default __webpack_public_path__ + "static/media/my-photo.34bfa3f5.jpg";